import { lazyLoad } from 'app/utils/loadable';

export const MainPage = lazyLoad(
  () => import('./main-page'),
  (module) => module.MainPage
);
